import React from 'react';
import { IconButton } from '@mui/material';
import TableViewIcon from '@mui/icons-material/TableView';
import { useCurrentEditor, useEditorState } from '@tiptap/react';

const ToolbarTableButton = () => {
	const { editor } = useCurrentEditor();

	const { isActive } = useEditorState({
		editor,
		selector: (ctx) => {
			return {
				isActive: ['table', 'th', 'tr', 'td'].some((v) => ctx.editor?.isActive(v)),
			};
		},
	});

	return (
		<IconButton
			size='small'
			onClick={() => {
				editor.chain().focus().insertTable({ rows: 3, cols: 3, withHeaderRow: true }).run();

				setTimeout(
					() => editor.chain().focus().toggleHeaderRowBold().applyHeaderRowStyles().run(),
					10
				);
			}}
			disabled={isActive}
		>
			<TableViewIcon />
		</IconButton>
	);
};

export default ToolbarTableButton;
